import { Component, Input } from '@angular/core';
import { BreadcrumbItems } from '../../typing';

@Component({
  selector: 'bcsc-digi-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {

  @Input() breadcrumbItems: BreadcrumbItems[] = [];

}
